import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import addDeleteGetLocalStorage from "../prototype/addDeleteGetLocalStorage";
import { STORAGE } from "../Common/LocalVariable";

const AdminPrivateRoutes = () => {
  const userAccess = addDeleteGetLocalStorage(STORAGE?.USER_TOKEN, {}, "get");
  return <>{userAccess ? <Outlet /> : <Navigate to="/n146m149" />}</>;
};

export default AdminPrivateRoutes;
